module.exports = {
	en: require("./en"),
	de: require("./de"),
};
